<div class="d-flex flex-column align-items-center rounded px-4 pt-2" style="background: #252525;  max-width: 400px;">
    <h3 class="text-white py-3 m-0"> <i *ngIf="icon != null && icon.trim() != ''" [ngClass]="[icon]" class="mdi"></i> {{title}}</h3>
    <p class=" pb-4 px-3 m-0 text-white" style="text-align:center;" [innerHTML]="message|safeHtml"></p>
    <div class="d-flex flex-row justify-content-between w-100 p-3" style="border-top: 1px solid #fff2;">
        <button *ngIf="canCancel" (click)="cancel()">{{cancelText}}</button>
        <button (click)="confirm()" class="ml-auto">{{confirmText}}</button>
    </div>
</div>